import { lazy } from 'react'

export const MuiPickersUtilsProvider = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({
    default: val.MuiPickersUtilsProvider,
  }))
)
export const KeyboardTimePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({ default: val.KeyboardTimePicker }))
)
export const KeyboardDatePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({ default: val.KeyboardDatePicker }))
)
export const KeyboardDateTimePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({
    default: val.KeyboardDateTimePicker,
  }))
)
export const DatePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({ default: val.DatePicker }))
)
export const DateTimePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({ default: val.DateTimePicker }))
)
export const TimePicker = lazy(() =>
  import('@material-ui/pickers' /* webpackChunkName: "pickers" */).then((val) => ({ default: val.TimePicker }))
)
